import { formatDate } from 'helpers/datesHelper.js';
const encode = encodeURIComponent;
const today = new Date();

export default (requests, axios) => {
  return {
    getFreebetByFilter: ({
      activeTab = 'ACTIVE',
      endDate = today,
      startDate = today,
      limit = 10,
      currentPage = 0,
      forceEncoded = false,
    } = {}) => {
      const offset = currentPage * limit;
      const dateFrom = formatDate(startDate, 'yyyy-MM-dd');
      const dateTo = formatDate(endDate, 'yyyy-MM-dd');
      
      const sessionCookie = Cookies.get('X-ODDS-SESSION');
      const config = {};
      if (sessionCookie) {
        config['headers'] = { 'X-ODDS-SESSION': sessionCookie };
      }
      return requests.get(
        `/public/offers/freebet/${dateFrom}/${dateTo}/${limit + 1}/${offset}/?status=${encode(
          activeTab.toUpperCase()
        )}${forceEncoded ? '&encoded=true' : ''}`,
        config
      );
    },
  };
};
